'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _govBraftEditor = require('@alife/gov-braft-editor');

var _govBraftEditor2 = _interopRequireDefault(_govBraftEditor);

var _braftUtils = require('@alife/braft-utils');

var _table = require('braft-extensions/dist/table');

var _table2 = _interopRequireDefault(_table);

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _ossUploadHelper = require('../common/oss-upload-helper');

require('@alife/gov-braft-editor/dist/index.css');

require('braft-extensions/dist/table.css');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var excludeControls = ['media', 'fullscreen'];
var tableOptions = {
  defaultColumns: 3, // 默认列数
  defaultRows: 3, // 默认行数
  withDropdown: false, // 插入表格前是否弹出下拉菜单
  exportAttrString: '' // 指定输出HTML时附加到table标签上的属性字符串
};
// 由全局变量控制是否开启富文本Table能力
if (window.globalGovMessage && window.globalGovMessage['FormRender.RichText.TableEnable'] === true) {
  _govBraftEditor2.default.use((0, _table2.default)(tableOptions));
}
var RichTextField = (_temp = _class = function (_Field) {
  _inherits(RichTextField, _Field);

  function RichTextField(props) {
    _classCallCheck(this, RichTextField);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _initialiseProps.call(_this);

    _this.editorInstance = null;
    var value = props.fieldData && props.fieldData.value;
    var editorState = _govBraftEditor2.default.createEditorState(value);
    _this.state = _extends({}, _this.state, {
      editorState: editorState, // 设置编辑器初始内容
      outputHTML: value
    });
    return _this;
  }

  RichTextField.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var nextVal = this.props.fieldData && this.props.fieldData.value;
    if (prevState.outputHTML === this.state.outputHTML && this.state.outputHTML !== nextVal) {
      this.setState({
        editorState: _govBraftEditor2.default.createEditorState(nextVal),
        outputHTML: nextVal
      });
    }
  };

  RichTextField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-rich-text',
      labelAlign: 'top'
    });
  };

  RichTextField.prototype.renderView = function renderView() {
    var contentHeight = this.props.contentHeight;

    var value = this.getValue();
    return _react2.default.createElement(
      'div',
      { className: 'editor-wrapper readonly', style: { height: contentHeight } },
      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: value } })
    );
  };

  RichTextField.prototype.renderControl = function renderControl() {
    var _this2 = this;

    var behavior = this.getBehavior();
    var contentHeight = this.props.contentHeight;
    var editorState = this.state.editorState;

    return _react2.default.createElement(
      'div',
      { className: 'editor-wrapper' },
      _react2.default.createElement(_govBraftEditor2.default, {
        ref: function ref(instance) {
          return _this2.editorInstance = instance;
        },
        value: editorState,
        readOnly: behavior !== 'NORMAL',
        onChange: this.handleChange,
        excludeControls: excludeControls
        // extendControls={this.extendControls}
        , contentStyle: { height: contentHeight }
      })
    );
  };

  _createClass(RichTextField, [{
    key: 'extendControls',
    get: function get() {
      var global = this.props.global;

      return [{
        key: 'uxcore-uploader',
        type: 'component',
        component: _react2.default.createElement(
          _next.Upload,
          {
            accept: 'image/*',
            beforeUpload: function beforeUpload(file, options) {
              return (0, _ossUploadHelper.beforeUpload)(file, options, _extends({}, (0, _lodash.get)(global, 'formOptions', {}), {
                sceneName: 'RICH_TEXT_FILE'
              }));
            },
            formatter: this.formatter,
            onSuccess: this.onUploadSuccess
          },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'control-item button upload-button', 'data-title': '\u63D2\u5165\u56FE\u7247' },
            '\u63D2\u5165\u56FE\u7247'
          )
        )
      }];
    }
  }]);

  return RichTextField;
}(_vuFusionField2.default), _class.displayName = 'RichText', _class.validators = {
  minLength: {
    valid: function valid(value, param) {
      return value && value.length >= param;
    }
  },
  maxLength: {
    valid: function valid(value, param) {
      return !value || value.length <= param;
    }
  }
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.formatter = function (res, file) {
    return {
      success: true,
      url: file.ossUrl,
      fileKey: file.fileKey
    };
  };

  this.onUploadSuccess = function (file, value) {
    (0, _ossUploadHelper.registerFile)(file.name, file.originFileObj && file.originFileObj.fileKey);
    _this3.setState({
      editorState: _braftUtils.ContentUtils.insertMedias(_this3.state.editorState, [{
        type: 'IMAGE',
        url: file.url
      }])
    });
  };

  this.handleChange = function (editorState) {
    var onChange = _this3.props.onChange;

    var outputHTML = editorState.isEmpty() ? '' : editorState.toHTML();
    _this3.setState({
      editorState: editorState,
      outputHTML: outputHTML
    }, function () {
      // 将 outputHTML 存到 fieldData 中
      if (onChange) {
        onChange({ value: outputHTML });
      }
    });
  };
}, _temp);
exports.default = RichTextField;
module.exports = exports['default'];